import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import ComponentBase, { addAllEventsOnGraphic, removeAllEventsFromGraphic } from './component-base';

var UNDEF,
    addEventOnAllGraphics = function addEventOnAllGraphics(a, b, c) {
  var d;
  b && c && (d = function d(a) {
    !a._skipEvents && a.on && a.on(b, c);
  }, _mapSubFnForward(a.getGraphicalElement(), d));
},
    removeEventFromAllGraphics = function removeEventFromAllGraphics(a, b, c) {
  var d;
  b && c && (d = function d(a) {
    !a._skipEvents && a.off && a.off(b, c);
  }, _mapSubFnForward(a.getGraphicalElement(), d));
},
    _mapSubFnBackward = function _mapSubFnBackward(a, b) {
  if (a && a.hasOwnProperty && b && b.call) {
    var c, d, e, f;

    for (d in a) {
      for (c = a[d], e = c.elemStore, f = e && e.length - 1; 0 <= f && !b(e[f], d, f); f--) {
        ;
      }
    }
  }
},
    _mapSubFnForward = function _mapSubFnForward(a, b) {
  if (a && a.hasOwnProperty && b && b.call) {
    var c, d, e, f, g;

    for (e in a) {
      for (c = a[e], f = c.elemStore, (g = 0, d = f && f.length); g < d && !b(f[g], e, g); g++) {
        ;
      }
    }
  }
},
    _getDifferentialAttributes = function _getDifferentialAttributes(a, b) {
  var c, d, e, f;

  for (f in a) {
    d = a[f], e = typeof d, void 0 === b[f] ? (c || (c = {}), c[f] = d) : 'object' === e ? d.toString().replace(/,/g, '') !== b[f].toString().replace(/,/g, '') && (c || (c = {}), c[f] = d) : 'string' === e ? d.replace(/,/g, '') !== b[f].toString().replace(/,/g, '') && (c || (c = {}), c[f] = d) : d !== b[f] && (c || (c = {}), c[f] = d);
  }

  return c;
};

var SmartRenderer =
/*#__PURE__*/
function (_ComponentBase) {
  _inherits(SmartRenderer, _ComponentBase);

  function SmartRenderer(a) {
    var _this;

    _classCallCheck(this, SmartRenderer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SmartRenderer).call(this));

    var b = _assertThisInitialized(_assertThisInitialized(_this));

    b._id = a, b._componentStore = {}, b._oldComponentStore = [], b.fireEvent('instantiated'), b.__setDefaultConfig();
    return _this;
  }

  _createClass(SmartRenderer, [{
    key: "isDrawingRequired",
    value: function isDrawingRequired() {
      return this;
    }
  }, {
    key: "syncDraw",
    value: function syncDraw() {
      this.isDrawingRequired() && (this._removeUnusedComponent(), this._resetGraphicalStore(), _get(_getPrototypeOf(SmartRenderer.prototype), "syncDraw", this).call(this), this._removeUnusedGraphics());
    }
  }, {
    key: "setDimension",
    value: function setDimension(a, b) {
      this.config.width = a, this.config.height = b;
    }
  }, {
    key: "setTranslation",
    value: function setTranslation(a, b) {
      var c = this,
          d = c.config;
      d._translateX = a, d._translateY = b, d.translate = "t".concat(a, ",").concat(b);
    }
  }, {
    key: "getTranslation",
    value: function getTranslation() {
      return {
        x: this.config._translateX,
        y: this.config._translateY
      };
    }
  }, {
    key: "_resetGraphicalStore",
    value: function _resetGraphicalStore() {
      var a = this;
      a._oldGraphicalStore = a._graphicalStore, a._graphicalStore = {};
    }
  }, {
    key: "_getLastUsedElem",
    value: function _getLastUsedElem() {
      return this.config.lastElemUsed;
    }
  }, {
    key: "addGraphicalElement",
    value: function addGraphicalElement() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var b = arguments.length > 1 ? arguments[1] : undefined;
      var c,
          d,
          e,
          f,
          g = this,
          h = g.getFromEnv('animationManager'),
          i = a.label,
          j = g._graphicalStore[i] || (g._graphicalStore[i] = {
        elemStore: [],
        idMap: {},
        indexMap: {},
        lastIndexUsed: -1
      }),
          k = !0,
          l = g._oldGraphicalStore && g._oldGraphicalStore[i],
          m = j.lastIndexUsed += 1,
          n = a.attr,
          o = a.id;
      l && (o && l.idMap[o] !== void 0 ? (e = l.idMap[o], f = l.elemStore[e], delete l.elemStore[e], delete l.indexMap[e], delete l.idMap[o]) : l.elemStore[m] && !l.indexMap[m] && (f = l.elemStore[m], delete l.elemStore[m])), f && (a.el = f, k = !1, (n = _getDifferentialAttributes(a.attr, f.attrs)) && (a.attr = n)), (d = a.container) ? (c = d.isParent ? g.getLinkedParent() : g, a.container = c.getGraphicalElement(d.id, d.label) || c.getChildContainer(d.id)) : a.container = g.getFromEnv('chart-container'), n && (f = h.setAnimation(a)), j.elemStore[m] = f, o && (j.idMap[o] && (delete j.indexMap[j.idMap[o]], delete j.idMap[o]), j.idMap[o] = m, j.indexMap[m] = o), g.fireEvent('graphicalelementattached', {
        element: f
      }), f._skipEvents = b, a.shadow && f.shadow(a.shadow), a.tooltext && g.getFromEnv('toolTipController').enableToolTip(f, a.tooltext), g.config.lastElemUsed = f, !b && k && addAllEventsOnGraphic(f, g._middleListeners, g);
    }
  }, {
    key: "removeGraphicalElement",
    value: function removeGraphicalElement(a, b) {
      var c,
          d,
          e,
          f,
          g = this,
          h = g._graphicalStore;
      'object' == typeof a ? _mapSubFnBackward(h, function (b, d, e) {
        if (a === b) return f = !0, b._skipEvents || removeAllEventsFromGraphic(b, g._middleListeners), g._setRemoveAnim(b, d), c = h[d], c.elemStore.splice(e, 1), delete c.idMap[c.indexMap[e]], delete c.indexMap[e], !0;
      }) : _mapSubFnBackward(h, function (d, j, k) {
        if (c = h[j], e = c.indexMap, e[k] === a && (!b || b === j)) return f = !0, d._skipEvents || removeAllEventsFromGraphic(d, g._middleListeners), g._setRemoveAnim(d, j), c.elemStore.splice(k, 1), delete c.idMap[c.indexMap[k]], delete c.indexMap[k], !0;
      }), f && this.fireEvent('graphicalelementremoved', {
        element: d
      });
    }
  }, {
    key: "getChildContainer",
    value: function getChildContainer(a) {
      return this.getGraphicalElement(UNDEF, a);
    }
  }, {
    key: "_removeUnusedGraphics",
    value: function _removeUnusedGraphics() {
      var a,
          b = this,
          c = b._oldGraphicalStore;

      _mapSubFnBackward(c, function (d, e, f) {
        d && (!d._skipEvents && removeAllEventsFromGraphic(d, b._middleListeners), b._setRemoveAnim(d, e), a = c[e], delete a.idMap[a.indexMap[f]], delete a.indexMap[f]);
      });
    }
  }, {
    key: "getGraphicalElement",
    value: function getGraphicalElement(a, b) {
      var c,
          d,
          e,
          f,
          g,
          h = this,
          j = h._graphicalStore;
      return b || a ? b ? (c = j[b], a ? c && c.elemStore && c.elemStore[c.idMap[a]] : c && c.elemStore && c.elemStore[0]) : (_mapSubFnForward(j, function () {
        if (g = arguments[2], e = j[arguments[1]], d = e.idMap, d[g] === a) return f = e.elemStore[g], !0;
      }), f) : j;
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(a, b, c) {
      var d = _get(_getPrototypeOf(SmartRenderer.prototype), "addEventListener", this).call(this, a, b, c);

      return !0 === d ? (addEventOnAllGraphics(this, a, this._middleListeners[a]), b) : !!d && b;
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(a, b) {
      _get(_getPrototypeOf(SmartRenderer.prototype), "removeEventListener", this).call(this, a, b) && removeEventFromAllGraphics(this, a, this._middleListeners[a]);
    }
  }, {
    key: "_dispose",
    value: function _dispose() {
      var a,
          b = this;

      if (_get(_getPrototypeOf(SmartRenderer.prototype), "_dispose", this).call(this)) {
        for (a in b.getFromEnv('paper') && !b.getFromEnv('paper').removed && _mapSubFnForward(b.getGraphicalElement(), b.__instantRemoveFn), b) {
          b.hasOwnProperty(a) && delete b[a];
        }

        b.fireEvent('removed');
      }
    }
  }, {
    key: "removingDraw",
    value: function removingDraw() {
      var a = this;

      _mapSubFnForward(a.getGraphicalElement(), a._setRemoveAnim);
    }
  }, {
    key: "configure",
    value: function configure(a) {
      this._resetComponentStore(), _get(_getPrototypeOf(SmartRenderer.prototype), "configure", this).call(this, a);
    }
  }, {
    key: "_resetComponentStore",
    value: function _resetComponentStore() {
      var a = this;
      a._oldComponentStore.push(a._componentStore), a._componentStore = {};
    }
  }, {
    key: "_mapChildren",
    value: function _mapChildren(a, b) {
      b ? _mapSubFnBackward(this.getChildren(), a) : _mapSubFnForward(this.getChildren(), a);
    }
  }, {
    key: "attachChild",
    value: function attachChild(a, b, c) {
      var d,
          e,
          f = this,
          g = f._componentStore[b] || (f._componentStore[b] = {
        elemStore: [],
        idMap: {},
        indexMap: {},
        lastIndexUsed: -1
      }),
          h = f._oldComponentStore && f._oldComponentStore.length && f._oldComponentStore[f._oldComponentStore.length - 1][b],
          i = g.lastIndexUsed += 1;
      return h && (c && void 0 !== h.idMap[c] ? (d = h.idMap[c], e = h.elemStore[d], delete h.elemStore[d], delete h.indexMap[d], delete h.idMap[c]) : h.elemStore[i] && !h.indexMap[i] && (e = h.elemStore[i], delete h.elemStore[i])), e || (e = new a(c)), g.elemStore[i] = e, c && (g.idMap[c] = i, g.indexMap[i] = c), e._setLinkedParent(f), f.fireEvent('childattached', {
        attachedChild: e
      }), e;
    }
  }, {
    key: "_removeUnusedComponent",
    value: function _removeUnusedComponent() {
      var a = this,
          b = a._oldComponentStore,
          c = b.length,
          d = 0,
          e = function e(a, c, _e) {
        var f;
        a && (f = b[d][c], delete f.idMap[f.indexMap[_e]], delete f.indexMap[_e], a.remove());
      };

      for (; d < c; d += 1) {
        _mapSubFnBackward(b[d], e);
      }

      a._oldComponentStore.length = 0;
    }
  }, {
    key: "getChild",
    value: function getChild(a, b) {
      var c;
      return this._searchChildren(a, function (a) {
        c = a;
      }, b), c;
    }
  }, {
    key: "_searchChildren",
    value: function _searchChildren(a, b, c) {
      var d,
          e,
          f,
          g,
          h = this,
          j = h._componentStore;
      if (a ? _mapSubFnBackward(j, function (b, h, k) {
        if (d = j[h], f = d.indexMap, f[k] === a && (!c || c === h)) return g = b, e = k, c = h, !0;
      }) : g = j[c] && j[c].elemStore, g) return b(g, e, c);
    }
  }, {
    key: "getChildren",
    value: function getChildren(a) {
      return a ? this._componentStore[a] && this._componentStore[a].elemStore : this._componentStore;
    }
  }, {
    key: "detachChild",
    value: function detachChild(a) {
      var b,
          c,
          d = this,
          e = d._componentStore;
      return a === UNDEF ? UNDEF : (d._searchChildren(a, function (a, f, g) {
        c = e[g], c.elemStore.splice(f, 1), delete c.idMap[c.indexMap[f]], delete c.indexMap[f], a._setLinkedParent(UNDEF), b = a, d.fireEvent('childdetached', {
          detachedChild: b
        });
      }), b);
    }
  }]);

  return SmartRenderer;
}(ComponentBase);

export default SmartRenderer;